import React, { useEffect, useState } from 'react'
import { useAuth0 } from "@auth0/auth0-react";
import {
    Box,
    Tab,
    Tabs,
    Typography,
} from '@mui/material';

import { tabsClasses } from '@mui/material/Tabs';

import LargeKeyValue from '../../components/display/LargeKeyValue';
import SmallKeyValue from '../../components/display/SmallKeyValue'
import ShortDataGrid from '../../components/datagrid/ShortDataGrid';


export default function ShotDetailPageMobile(props) {
    const { shotData } = props
    const [value, setValue] = React.useState(0);
    const [shotDetailTabs, setShotDetailTabs] = useState(['Summary'])

    const columns = [
        { field: 'key', headerName: 'Metadata', flex: 1 },
        { field: 'value', headerName: 'Value', flex: 1 },
    ];

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleDetail = (data) => {
        const newArray = [...shotDetailTabs, data];
        if (!shotDetailTabs.includes(data)) {
            setShotDetailTabs(newArray);
        }
    }

    useEffect(() => {
        if(shotData.metadata){
            handleDetail('Metadata')
        }
        if(shotData.Framedata){
            handleDetail('Framedata')
        }
    }, [shotData])

    return (
        <React.Fragment>
            <Box
                display="flex"
                flexDirection="column" 
                width='100%'
                height='100%'
            >
                <Box
                    mt={3}
                    width={'100%'}
                    display={'flex'}
                    flexDirection={'column'}
                    alignItems={'center'}
                >
                    {
                        Object.keys(shotData).includes('thumbnail')
                        ?
                        <img
                            alt="thumbnail"
                            width="160px"
                            height="90px"
                            src={`data:image/png;base64, ${shotData.thumbnail}`}
                        />
                        :
                        <Box height='90px' width='160px' />

                    }
                    <Typography sx={{color: 'white'}} variant="h7" paddingBottom='20px'>{shotData.ClipName}</Typography>
                    <Box
                        sx={{
                            maxWidth: '75vw',
                        }}
                    >
                        <Tabs
                            value={value}
                            onChange={handleTabChange}
                            indicatorColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                            sx={{
                                [`& .${tabsClasses.scrollButtons}`]: {
                                    '&.Mui-disabled': { opacity: 0.2 },
                                },
                            }}>
                            {shotDetailTabs.map((tab, index) => (
                                <Tab
                                    key={index}
                                    label={tab}
                                    style={{
                                        minWidth: 'auto',
                                        margin: 0,
                                        textTransform: 'none',
                                        fontWeight: 'bold',
                                        color: 'white'
                                    }} 
                                />
                            ))}
                        </Tabs>
                    </Box>
                </Box>
                {
                    shotDetailTabs[value] === 'Summary'
                    ?
                    <Box
                        width='100%'
                        height='100%'
                        overflow='auto'
                    >
                        <Box
                            display="flex"
                            flexDirection='column'
                            justifyContent='center'
                            width="100%"
                            paddingLeft="10%"
                        >
                            <SmallKeyValue
                                keyLabel="Transfer Date"
                                value={shotData.TransferDate}
                                alignItems="left"
                                highlighted
                            />
                            <SmallKeyValue
                                keyLabel='Episode'
                                value={shotData.Episode}
                                alignItems="left"
                                highlighted
                            />
                            <SmallKeyValue
                                keyLabel='Scene'
                                value={shotData.Scene}
                                alignItems="left"
                                highlighted
                            />
                            <SmallKeyValue
                                keyLabel='Take'
                                value={shotData.Take}
                                alignItems="left"
                                highlighted
                            />
                            <SmallKeyValue
                                keyLabel='Camera'
                                value={shotData.Camera}
                                alignItems="left"
                                highlighted
                            />
                        </Box>
                    </Box>
                    :
                    <></>
                }
                {
                    shotDetailTabs[value] === 'Metadata'
                    ?
                    <Box
                        height={'100%'}
                        m={3}
                    >
                    <ShortDataGrid 
                        rows={shotData?.metadata || []}
                        columns={columns} 
                        pageSize={18} 
                        rowHeight={50}
                    />
                    </Box>
                    :
                    <></>
                }
                {
                    shotDetailTabs[value] === 'Framedata'
                    ?
                    <Box
                        height={'100%'}
                        m={3}
                    >
                    <ShortDataGrid 
                        rows={shotData?.Framedata || []}
                        columns={shotData?.framecols || columns} 
                    />
                    </Box>
                    :
                    <></>
                }
            </Box>
        </React.Fragment>
    )
}